/**
 * CenterSlice Selectors
 * 
 * Memoized selectors for accessing center slice state.
 * Uses createSelector for performance optimization.
 */

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { CenterSliceState } from './state';

// Base selector to get the center slice
const selectCenterSlice = (state: RootState): CenterSliceState => state.center;

// =============================================================================
// CORE SELECTORS
// =============================================================================

/**
 * Select the currently selected center code
 */
export const selectSelectedCenter = createSelector(
  selectCenterSlice,
  (slice) => slice.selectedCenter
);

/**
 * Select whether a center is selected
 */
export const selectHasSelectedCenter = createSelector(
  selectSelectedCenter,
  (selectedCenter) => selectedCenter !== ''
);
